const CONSENT_KEY = 'cookie-consent'

export function getConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_KEY)
    if (!raw) return { essential: true, analytics: null }
    const parsed = JSON.parse(raw)
    return {
      essential: true,
      analytics: parsed?.analytics ?? null,
    }
  } catch (_) {
    return { essential: true, analytics: null }
  }
}

export function setConsent(consent) {
  const next = {
    essential: true,
    analytics: !!consent.analytics,
  }
  localStorage.setItem(CONSENT_KEY, JSON.stringify(next))
  window.dispatchEvent(new CustomEvent('cookie-consent-changed', { detail: next }))
}

export function hasConsented(category) {
  const c = getConsent()
  if (category === 'essential') return true
  if (category === 'analytics') return c.analytics === true
  return false
}

export function resetConsent() {
  try {
    const next = { essential: true, analytics: null }
    localStorage.setItem(CONSENT_KEY, JSON.stringify(next))
    window.dispatchEvent(new CustomEvent('cookie-consent-changed', { detail: next }))
  } catch (_) {}
}
